import { expVal } from '@atlassian/jira-feature-experiments';

const BoardHarmonisationMilestone3 = {
	get(): boolean {
		return expVal('board_harmonisation_m3_swimlanes', 'isEnabled', false);
	},
};

export default BoardHarmonisationMilestone3;
